import { create } from "zustand";

interface ChatState {
    isChatListOpen: boolean;
    pendingOpenUserId: string | null;
    openConversations: string[]; // IDs of active chat windows
    minimizedConversations: string[]; // IDs of minimized windows

    toggleChatList: () => void;
    ensureChatListOpen: () => void;
    openChatWithUser: (userId: string) => void;
    clearPendingOpenUserId: () => void;
    openConversation: (conversationId: string) => void;
    minimizeConversation: (conversationId: string) => void;
    closeConversation: (conversationId: string) => void;
    maximizeConversation: (conversationId: string) => void;
}

export const useChatStore = create<ChatState>((set) => ({
    isChatListOpen: false,
    pendingOpenUserId: null,
    openConversations: [],
    minimizedConversations: [],

    toggleChatList: () => set((state) => ({
        isChatListOpen: !state.isChatListOpen
    })),

    ensureChatListOpen: () => set({ isChatListOpen: true }),

    openChatWithUser: (userId) =>
        set({ isChatListOpen: true, pendingOpenUserId: userId }),

    clearPendingOpenUserId: () => set({ pendingOpenUserId: null }),

    openConversation: (conversationId) =>
        set(() => ({
            openConversations: [conversationId],
            minimizedConversations: [],
        })),

    minimizeConversation: (conversationId) => set((state) => {
        if (!state.minimizedConversations.includes(conversationId)) {
            return { minimizedConversations: [...state.minimizedConversations, conversationId] };
        }
        return {};
    }),

    maximizeConversation: (conversationId) => set((state) => ({
        minimizedConversations: state.minimizedConversations.filter(id => id !== conversationId)
    })),

    closeConversation: (conversationId) => set((state) => ({
        openConversations: state.openConversations.filter(id => id !== conversationId),
        minimizedConversations: state.minimizedConversations.filter(id => id !== conversationId)
    })),
}));
